import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../../services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  _apiUrl: string = '';

  constructor(
    private authenticationService: AuthenticationService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get language
    const language = localStorage.getItem('language') || 'it';
    // add auth header with jwt if user is logged in and request is to api url
    const accessToken = this.authenticationService.getAuthorizationToken();
    const isLoggedIn = this.authenticationService.isLogged();
    const apiUrl = this.authenticationService.getApiUrl();
    const isApiUrl = request.url.startsWith(apiUrl);
    if (isLoggedIn && isApiUrl) {
      // console.log('JwtInterceptor Authorization', accessToken);
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
          'Accept-Language': language
        }
      });
    }

    return next.handle(request);
  }
}
